import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMusicNote32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconMusicNote32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M11 6a1 1 0 0 1 1-1h15a1 1 0 0 1 1 1v16q0 .081-.013.16.013.168.013.34a4.5 4.5 0 1 1-2-3.742V11H13v11q0 .081-.013.16.013.168.013.34a4.5 4.5 0 1 1-2-3.742zm2 3h13V7H13zm-2 13.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0m15 0a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconMusicNote32);
